import Skeleton from "@atlaskit/skeleton";
import type {ComponentProps} from "react";

export function AnankeSkeleton(props: ComponentProps<typeof Skeleton>) {
    return <Skeleton {...props} />;
}
